<template>
  <span>
    <s-icon
      name="hint"
      class="info-badge__icon"
      :class="iconModifiers"
      :id="iconId"
      @click="onIconClick"
    />
    <b-tooltip
      :target="iconId"
      :triggers="allTriggers"
      :placement="placement"
      :boundary="boundary"
      :container="container"
      :custom-class="tooltipCustomClass"
    >
      <slot>
        <span v-html="badgeText"></span>
      </slot>
    </b-tooltip>
  </span>
</template>

<script>
import { createId } from '@/services/createId';

const idPrefix = 'info-badge-';

const interactableTooltipDelay = 8000;

export default {
  props: {
    /**
     * Chave de tradução. Opcional, caso não usada, pode-se passar o conteúdo via slot principal.
     */
    translationKey: {
      type: String,
      required: false,
    },
    stringKey: {
      type: String,
      required: false,
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    placement: {
      type: String,
      default: 'right',
    },
    boundary: {
      type: String,
      default: 'viewport',
    },
    interactableTooltip: {
      type: Boolean,
      default: false,
    },
    container: {
      type: String,
      default: null,
    },
    tooltipCustomClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    iconId: createId(idPrefix),
    hideTimeout: null,
  }),
  computed: {
    allTriggers() {
      if (this.interactableTooltip && !this.trigger.includes('click')) {
        return `${this.trigger} click`;
      }

      return this.trigger;
    },
    iconModifiers() {
      return {
        'info-badge__icon_interactable': this.interactableTooltip,
      };
    },
    badgeText() {
      return this.$t(this.translationKey) || this.stringKey;
    },
  },
  methods: {
    onIconClick() {
      if (!this.interactableTooltip) {
        return;
      }

      if (this.hideTimeout != null) {
        clearTimeout(this.hideTimeout);
      }

      this.hideTimeout = setTimeout(() => {
        this.hideTimeout = null;
        this.$root.$emit('bv::hide::tooltip', this.iconId);
      }, interactableTooltipDelay);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.info-badge
  &__icon
    color: var(--color-info)
    &_interactable
      cursor: pointer
.tooltip.b-tooltip
  z-index: 2000
</style>
